/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import Banners from '../../../stores/banners';
import Banner from '../../../stores/banner/banner';
import BannerUtil from './bannerUtil';
import LoggerUtil from '../../LoggerUtil';

import { LEFT_NAV_KEYS, APPS_COMPONENT_ID } from '../../enums';

const COMPONENT_ID = 'CategoriesBannerModelMapper';

class CategoriesBannerModelMapper {
    clearCategoriesBanners() {
        const filteredBanners = Banners.filterBanners({
            appSectionFilter: LEFT_NAV_KEYS.ALL_APPS_KEY,
        }, true);
        filteredBanners.forEach((banner) => {
            Banners.removeBanner(banner);
        });
    }

    setCategoriesBanners(bannersJson, onAction, basePath) {
        Banners.setBannerLoaded('category');
        if (!bannersJson) {
            return null;
        }
        return BannerUtil.contentToBannerModel({
            bannersJson,
            bannerAdder: (layoutId, bannerItemList, appSectionFilterKey) => {
                LoggerUtil.info(`${APPS_COMPONENT_ID}: ${COMPONENT_ID}: Adding banner for Category with ID: ${appSectionFilterKey}`);
                Banners.addBanner((new Banner({
                    layoutId,
                    bannerItemList,
                    appSectionFilter: [this.keyToCategoryId(appSectionFilterKey)],
                })));
            },
            onAction,
            basePath,
        });
    }

    /**
     * Returns a String Object in which all '_' should be replaced to '-'.
     * Categories Id doesn't have '_', hence a mapping is required.
     * @param key String parameter
     * @returns key String
     */
    keyToCategoryId(key) {
        return key.replace(/_/g, '-');
    }
}

export default new CategoriesBannerModelMapper();
